// Dashboard section URLs: /dashboard/<slug>. The portal's view keys mostly
// double as slugs; the exceptions are mapped here. Plain ESM with no Vite
// imports so scripts/prerender-shells.mjs can read the same list when it
// writes the product origin's _redirects.

// Sections the product (app.hollerpost.com) serves. Bare /dashboard is the
// Overview.
export const PRODUCT_DASHBOARD_SLUGS = [
  'campaigns', 'audience', 'forms', 'surveys', 'page', 'your-page', 'emails', 'automations', 'social', 'reports', 'settings', 'support',
];

const KEY_TO_SLUG = { contacts: 'audience' };
const SLUG_TO_KEY = {
  ...Object.fromEntries(Object.entries(KEY_TO_SLUG).map(([k, s]) => [s, k])),
  'your-page': 'page',
};

export const dashboardPath = (viewKey) =>
  !viewKey || viewKey === 'dashboard' ? '/dashboard' : `/dashboard/${KEY_TO_SLUG[viewKey] || viewKey}`;

export const viewKeyForSlug = (slug) => (slug ? SLUG_TO_KEY[slug] || slug : 'dashboard');
